export enum AuthType {
  login,
  signup,
}
